import { useEffect, useState } from 'react';
import type { OrderDetail } from '@/api/types';
import { api } from '@/api/client';
import { OrderExceptionCloseDialog } from '../orders/OrderExceptionCloseDialog';
import { OrderExceptionResolveDialog } from '../orders/OrderExceptionResolveDialog';
import type { ExceptionItem } from './types';
import s from './ExceptionActionDialog.module.css';

export type ExceptionAction = { kind: 'close' | 'resolve'; item: ExceptionItem };

export function ExceptionActionDialog({ action, can, onClose, onSuccess }: {
  action: ExceptionAction;
  can: (permission: string) => boolean;
  onClose: () => void;
  onSuccess: () => void;
}) {
  const [order, setOrder] = useState<OrderDetail>();
  const [error, setError] = useState('');
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    if (action.kind !== 'resolve') return;
    const controller = new AbortController();
    setOrder(undefined);
    setError('');
    void api.get<OrderDetail>(`/api/v2/orders/${action.item.order.id}`, undefined, controller.signal)
      .then(setOrder)
      .catch((cause: Error) => { if (cause.name !== 'AbortError') setError(cause.message); });
    return () => controller.abort();
  }, [action.kind, action.item.order.id, nonce]);

  if (action.kind === 'close') {
    return <OrderExceptionCloseDialog order={action.item.order} item={action.item} onClose={onClose} onSuccess={onSuccess} />;
  }
  const item = order?.exceptions.find((candidate) => candidate.id === action.item.id);
  if (order && item) {
    return <OrderExceptionResolveDialog order={order} item={item} can={can} onClose={onClose} onSuccess={onSuccess} />;
  }
  return <div className={s.backdrop}>
    <section className={s.dialog} role="dialog" aria-modal="true" aria-label="载入异常处理窗口">
      <h2>处理异常</h2>
      <p>{error || order ? error || '该异常已变化，请刷新列表后重试。' : '正在读取共享订单和最新异常状态…'}</p>
      <div className={s.actions}><button type="button" onClick={onClose}>返回</button>{error && <button type="button" onClick={() => setNonce((value) => value + 1)}>重试</button>}</div>
    </section>
  </div>;
}
